import { ref, query, equalTo, orderByChild } from "firebase/database";
import { useContext, useEffect, useState } from "react";
import { useList, useListVals } from "react-firebase-hooks/database";

import { database } from 'lib/firebase'
import { useLocation } from "./useLocation";
import { useDbQuery } from "./useDbQuery";
import { DataContext } from "contexts/DataContext";

export const useDevice = ({user}) => {

  const { devices, deviceUpdated } = useContext(DataContext)
  const [deviceItems, loadingDev, errorDev, refreshDev] = devices;
  const [updatedItems] = deviceUpdated;

  const [locations, loadingLoc, errorLoc, refreshLoc] = useLocation({ user })

  // When each device was last saved in the admin app (see lib/devices.js#deviceUpdatedTime)
  const updatedAt = new Map(updatedItems.map(u => [u.id, u.updated_at]))

  return [deviceItems.map(d => {
    d.location = locations.find(l => l.id === d.locationId) || null
    // Also cleared: the same device object comes back here when the times change
    if (updatedAt.has(d.id)) d.updatedAt = updatedAt.get(d.id)
    else delete d.updatedAt
    return d
  }), loadingDev || loadingLoc, errorDev || errorLoc, () => {
    refreshDev()
    refreshLoc()
  }];
};
